import Input from './Input';
import Group from './Group';
import Search from './Search';
import TextArea from './TextArea';
import Password from './Password';
Input.TextArea = TextArea;
Input.Group = Group;
Input.Password = Password;
Input.Search = Search;
export { Input };
export default Input;
